import get from "lodash-es/get";

export const getQueryName = (query, definition = 0) => {
  return get(query, `definitions.${definition}.name.value`);
};
